import { captchaAxios } from 'api/config'
import { ChatAttachment } from 'types/chat-attachment'

export const uploadChatAttachment = async (file: File, chatId: string): Promise<ChatAttachment> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('chatId', chatId)
  const { data } = await captchaAxios.post<ChatAttachment>('chat-attachments/upload', formData)
  return data
}

export const deleteChatAttachment = async (attachmentId: string): Promise<void> => {
  await captchaAxios.delete(`chat-attachments/${attachmentId}`)
}
